import Vue from "vue";
import Vuex from "vuex";
import VuexAlong from 'vuex-along'

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    loginType: sessionStorage.getItem("loginType") || false,
    user: {},
    phone: '',
    rechargeType: false,
    promotion: process.env.DOWNLOAD_POPUP, //disable app promote pop in the home page
    announcement_title: null,
    announcement_content: null,
    home_notice_content: null,
    home_logo_img: 'home_logo.png',
    login_logo_img: 'login_logo.png',
    home_logo_url: '',
    login_logo_url: '',
    searchSelectedShare: '',
    selectedCid: null,
    chat_server_url:'',
    /**
     * wonder chat system
     */
    message_list: [],
    channel_list: [],
    system_messages: [],
    system_message_unread: 0,
    wonder_chat_login_account: '',
    wonder_chat_token: null,
    wonder_chat_notice_sound: false,
    wonder_channel_notice_sound: false,
    message_threshold:(6*24*60*60*1000), //clear messages older than 6 days
  },
  mutations: {
    changeLoginType(state, type) {
      state.loginType = type;
    },
    changeUser(state, value) {
      state.user = value;
    },
    changePhone(state, value) {
      state.phone = value;
    },
    changePromotion(state, value) {
      state.promotion = value;
    },
    rechargeTypeNine(state, type) {
      state.rechargeType = type;
    },
    HomeLogoUrl(state, type) {
      state.home_logo_url = type;
    },
    LoginLogoUrl(state, type) {
      state.login_logo_url = type;
    },
    setSearchSecltedShare(state, value) {
      state.searchSelectedShare = value;
    },
    setSelectedCid(state, value) {
      state.selectedCid = value;
    },
    chatServerUrl(state, value){
      state.chat_server_url = value;
    },
    /**
     * wonder chat system
     */
    setWonderChatLoginAccount(state, account) {
      state.wonder_chat_login_account = account;
    },
    setWonderChatToken(state, token) {
      state.wonder_chat_token = token;
    },
    clearWonderChatToken(state){
      state.wonder_chat_token = null;
    },
    readSystemMessages(state) {
      state.system_message_unread = 0;
    },
    setMessage(state, dataObj) {
      let data = dataObj.message;
      if (data.action === "888") {
           // dataObj.caller.logout();
            return;
      }
      //handle channel message
      if (data.action === "1" || data.action === "3") {
              let channel = state.channel_list.find(o => o.id === parseInt(dataObj.sentMessage ? data.receiver : data.sender));
              if (!channel) {
                  if (!dataObj.sentMessage) {
                      data.read = false;
                      //show notice
                      //dataObj.caller.makeToast(data, channel);
                      //dataObj.caller.playSound();
                  }
                  let item = { id: parseInt(data.sender), unread: dataObj.sentMessage ? 0 : 1, timestamp: data.timestamp, messages: [data], user: { id: data.sender,username:"TODO" } };
                  state.channel_list.push(item);
                  dataObj.caller.getUserInfo(data.sender); //TODO call api to get channel information
              } else {
                  if (channel.messages.find(m => m.id == data.id)) {
                      return;
                  }
                  if (!dataObj.sentMessage) {
                      data.read = false;
                      channel.unread++;
                      //show notice
                      //dataObj.caller.makeToast(data, channel);
                      //dataObj.caller.playSound();
                  }
                  channel.messages.push(data);
                  channel.timestamp = data.timestamp
              }
              //sort list according to timestamp
              state.channel_list = state.channel_list.slice().sort((a, b) => b.timestamp - a.timestamp);
              return;
      }
      if (data.action !== "108") {
        if (data.sender === "system") {
          data.read = false;
          state.system_messages.push(data);
          state.system_message_unread++;
          return;
        }
        let account = state.message_list.find(o => o.id === (dataObj.sentMessage ? data.receiver : data.sender));
        if (!account) {
          if (!dataObj.sentMessage) {
            data.read = false;
            //show notice
            // dataObj.caller.makeToast(data, account); //TODO implement toast notification
          }
          let item = { id: data.sender, unread: dataObj.sentMessage ? 0 : 1, timestamp: data.timestamp, messages: [data], user: { account: data.sender } };
          state.message_list.push(item);
          dataObj.caller.getUserInfo(data.sender);
        } else {
          if (account.messages.find(m => m.id == data.id)) {
            return;
          }
          if (!dataObj.sentMessage) {
            data.read = false;
            account.unread++;
            //show notice
            // dataObj.caller.makeToast(data, account); //TODO implement toast notification
          }
          account.messages.push(data);
          account.timestamp = data.timestamp
        }
        //sort list according to timestamp
        state.message_list = state.message_list.slice().sort((a, b) => b.timestamp - a.timestamp);
      }

    },
    addMessageToHistory(state, data) {
      if (data.account === 'system') {
        state.system_messages = [];
        data.data.forEach(item => {
          // if(item.action === "888")return;
          item.id = item.id.toString();
          item.read = item.state == 2;
          state.system_messages.push(item);
        });
      } else {
        let accountData = state.message_list.find(o => o.id === data.account);
        data.data.forEach(item => {
          item.id = item.id.toString();
          item.read = item.state == 2;
          accountData.messages.push(item);
        });
        accountData.timestamp = data.data[data.data.length - 1].timestamp;
        // state.message_list = state.message_list.slice().sort((a, b) => b.timestamp - a.timestamp);
      }
      state.message_list = state.message_list.slice().sort((a, b) => b.timestamp - a.timestamp);
      this.commit('clearOlderMessages')
      // state.system_messages = state.system_messages.slice().sort((a, b) => b.timestamp - a.timestamp);
    },

    addMessageToHistoryChannel(state, data) {
        let accountData = state.channel_list.find(o => o.id === data.account);
        data.data.forEach(item => {
          item.id = item.id.toString();
          item.read = item.state == 2;
          accountData.messages.push(item);
        });
        accountData.timestamp = data.data[data.data.length-1].timestamp;
        state.channel_list = state.channel_list.slice().sort((a, b) => b.timestamp - a.timestamp);
    },

    setAgentList(state, data) {
      data.forEach(ele => {
        let item = { id: ele.id, unread: 0, user: ele, messages: [], account: ele.id, timestamp: 0 };
        state.message_list.push(item);

      });
    },

    readAllUnreadChannel(state, data) {
      let account = state.channel_list.find(o => o.id == data.account);
      if (account) {
          account.messages.forEach(message => {
              if (!message.read) {
                  message.read = true;
                  data.context.readRequest(message.id, data.account);
                  account.unread > 0 ? account.unread-- : account.unread = 0;
              }
          });
      }
    },
    clearMessageCache(state) {
      state.message_list = [];
    },
    clearChannelMessageCache(state) {
      state.channel_list = [];
    },
    updateMessageItem(state, data) {
      let account = state.message_list.find(o => o.id === data.id);
      if (account) {
        account = data;
      }
    },
    /**
         * get channel list from api and update store list
         * @param {*} state
         * @param {*} data
         */
     updateChannelList(state, data) {
      data.forEach(element => {
          let channel = state.channel_list.find(o => o.id === element.id);
          if(!channel){
              element.username = element.name;
              let item = {id:parseInt(element.id),unread:0, timestamp:null, messages:[],user:element, join:parseInt(element.join)};
              state.channel_list.push(item);
          }
        });
    },
    updateChannelJoinStatus(state, data) {
      let account = state.channel_list.find(o => o.id === data.channelId);
      account.join = data.data.joined;
    },
    updateUser(state, data) {
      data.id = data.account;
      data.username = data.user_name;
      let account = state.message_list.find(o => o.id === data.id);
      account.user = data;
    },
    updateWonderChatSound(state, data) {
      state.wonder_chat_notice_sound = data;
    },
    //1. search message list and remove messages older than threashold
    //TODO better to improve this method
    readAllUnread(state, data) {
      let account = state.message_list.find(o => o.id === data.account);
      if (account) {
          account.messages.forEach(message => {
              if (!message.read) {
                  message.read = true;
                  data.context.readRequest(message.id, data.account);
                  account.unread > 0 ? account.unread-- : account.unread = 0;
              }
          });
      }
    },
    updateWonderChannelSound(state, data) {
      state.wonder_channel_notice_sound = data;
    },
    //1. remove entire user if the last message older than threshold
    //2. search message list and remove messages older than threashold
    //TODO better to improve this method
    clearOlderMessages(state){
          let nowTimestamp = new Date();
          let oldestTimestamp = nowTimestamp - state.message_threshold;

          state.message_list.forEach(account => {
              if(account.timestamp < oldestTimestamp && account.unread == 0){
                  // state.message_list.splice(state.message_list.indexOf(account)) //to remove the chat agent from the list
              }else{
                  account.messages.forEach(message => {
                      if(message.timestamp < oldestTimestamp && message.read == true){
                          account.messages.splice(account.messages.indexOf(message),1)
                      }
                  });
              }
          });

      },
      clearChannelOlderMessages(state){
        let nowTimestamp = new Date();
        let oldestTimestamp = nowTimestamp - state.message_threshold;

        state.channel_list.forEach(id => {
            if(id.timestamp < oldestTimestamp && id.unread == 0){
                // state.channel_list.splice(state.channel_list.indexOf(id)) //to remove the channel from the list
            }else{
                id.messages.forEach(message => {
                    if(message.timestamp < oldestTimestamp && message.read == true){
                        id.messages.splice(account.messages.indexOf(message),1)
                    }
                });
            }
        });

    }
  },
  actions: {
  },
  plugins: [VuexAlong({
    name: 'along',
    local: { list: [], isFilter: true },
    session: false,
    justSession: false
  })]
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js